export const filterCars = (cars, selectedCategory, selectedTransmission, searchQuery) => {
  return cars.filter((car) => {
    const categoryMatch =
      selectedCategory === "all" || car.category === selectedCategory;
    const transmissionMatch =
      selectedTransmission === "all" ||
      car.transmission.toLowerCase() === selectedTransmission.toLowerCase();

    // Search in car main data
    const mainDataMatch =
      searchQuery === "" ||
      car.make.toLowerCase().includes(searchQuery.toLowerCase()) ||
      car.model.toLowerCase().includes(searchQuery.toLowerCase()) ||
      car.stringId?.toLowerCase().includes(searchQuery.toLowerCase());

    // Search in vehicle instances
    const vehicleInstanceMatch = car.vehicleInstances?.some(
      (vehicle) =>
        vehicle.licensePlate
          ?.toLowerCase()
          .includes(searchQuery.toLowerCase()) ||
        vehicle.vin?.toLowerCase().includes(searchQuery.toLowerCase()) ||
        vehicle.specialNotes
          ?.toLowerCase()
          .includes(searchQuery.toLowerCase()) ||
        vehicle.insurance?.provider
          ?.toLowerCase()
          .includes(searchQuery.toLowerCase())
    );

    return (
      categoryMatch &&
      transmissionMatch &&
      (mainDataMatch || vehicleInstanceMatch)
    );
  });
};
